// extracted by mini-css-extract-plugin
export default {"heading":"styles_heading__dKKGr","checkbox":"styles_checkbox__XfzgX","label":"styles_label__D0xN+","labelSelected":"styles_labelSelected__z67rR","spin":"styles_spin__r-1V8"};